import type { FacetSchema, FacetsSchema } from '../../types/common';

type Options = {
  dropEmptyFacets?: boolean;
  dropFacetNames?: string[];
};

export const facetsCleanup = (
  facets: FacetsSchema,
  { dropEmptyFacets = true, dropFacetNames = [] }: Options = {},
) => {
  const dropFacetNamesSet = new Set(dropFacetNames);

  const predicate = ([key, value]: [string, FacetSchema]) => {
    if (dropFacetNamesSet.has(key)) {
      return false;
    }
    if (
      dropEmptyFacets &&
      Array.isArray(value.buckets) &&
      value.buckets.length === 0
    ) {
      return false;
    }
    return true;
  };

  const result = Object.fromEntries(Object.entries(facets).filter(predicate));
  if (facets.current_facet_filters) {
    result.current_facet_filters = Object.fromEntries(
      Object.entries(facets.current_facet_filters).filter(predicate),
    );
  }

  return result;
};
